import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-enterprise';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
} from '@angular/core';

export interface CarveInCurrencyCellRendererParams {
  formattedSpend: string;
  isCarveIn?: boolean;
}

@Component({
    selector: 'app-carve-in-currency-cell-renderer',
    template: `
    <!-- prettier-ignore -->
    <div [attr.data-test-selector]="'last-12-months-spend-carve-in-'+formattedSpend"
        class="text-truncate" [ngClass]="{ 'text-excluded-spend-purple': isCarveIn }">
      {{ formattedSpend }}
    </div>
  `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CarveInCurrencyCellRendererComponent
  implements ICellRendererAngularComp
{
  constructor(private changeDetectorRef: ChangeDetectorRef) {}
  formattedSpend!: string;
  isCarveIn = false;

  agInit(params: CustomParams) {
    this.formattedSpend = params.formattedSpend;
    this.isCarveIn = !!params.isCarveIn;
    this.changeDetectorRef.detectChanges();
  }

  refresh(): boolean {
    return false;
  }
}

interface CustomParams
  extends ICellRendererParams,
    CarveInCurrencyCellRendererParams {}
